<template>
  <div class="group" style="padding-left: 10px">
    <div class="contentNew">
      <ul class="quyetdinh">
         <li style="list-style: none ; ">
          <a href="https://drive.google.com/file/d/15uhCecYC53Gs4PyFcxD45Shz-SVIhX32/view?usp=sharing"
            target="_blank">
            <span style="color: #0066cc; float: left">- Quy định của TGĐ về cập nhật hàng ngày giá trị/tiền thuê/khấu hao thiết bị trong HĐ CTV/đại lý/C1/C2/CN ngày 28/05/2026
            </span> 
          </a>
        </li>
        <li style="list-style: none ; ">
          <a href="https://drive.google.com/file/d/1I-4Io6dkwKQujPmI2ntooopHzZx57T7z/view?usp=sharing"
            target="_blank">
            <span style="color: #0066cc; float: left">- Quy định của TGĐ về về đại lý, hợp đồng và cộng tác viên đại lý ngày 27/05/2026
            </span> 
          </a>
        </li>
          <li style="list-style: none ; ">
          <a href="https://drive.google.com/file/d/1msgaxa3D4JHstLBHHf3y0nfNVepkicFD/view?usp=sharing"
            target="_blank">
            <span style="color: #0066cc; float: left">- Quy định của TGĐ về hợp đồng CTV và hợp đồng thiết bị đối với trường chuyên và xã, phường đặc biệt ngày 26/05/2026
            </span> 
          </a>
        </li>
          <li style="list-style: none ; ">
          <a href="https://drive.google.com/file/d/1oM1tHusfZ8sjJ5hPkVkwlHR7oH3bDbHF/view?usp=sharing"
            target="_blank">
            <span style="color: #0066cc; float: left">- Nghị quyết của HĐQT về việc hạch toán kinh doanh và phân bổ doanh thu sau giá vốn ngày 19/05/2026
            </span> 
          </a>
        </li>
        <li style="list-style: none ; ">
          <a href="https://drive.google.com/file/d/1s22_ttK-XkOnEOGzeCJvrjIkSIdKHvlN/view?usp=sharing"
            target="_blank">
            <span style="color: #0066cc; float: left">- Quyết định của TGĐ về lương theo KPI của nhân viên triển khai và Quỹ nhóm ngày 18/05/2026
            </span> 
          </a>
        </li>
         <li style="list-style: none ; ">
          <a href="https://drive.google.com/file/d/1U-pnx6fYsXnrPFHOuYp5O_6M0E20IF0E/view?usp=sharing"
            target="_blank">
            <span style="color: #0066cc; float: left">- Công văn đề nghị BIDV bán Euro để thành lập CTCP Vimass Hungary ngày 12/05/2026
            </span> 
          </a>
        </li>
           <li style="list-style: none ; ">
          <a href="https://drive.google.com/file/d/1uHB__TlN8AxOMNW9t1i2MuQ2Sba4D9r7/view?usp=sharing"
            target="_blank">
            <span style="color: #0066cc; float: left">- Thông báo ủy quyền chuyển khoản tài trợ ngày 12/05/2026
            </span> 
          </a>
        </li>
         <li style="list-style: none ; ">
          <a href="https://drive.google.com/file/d/1L5oGXfsci-qJ-K7lm7dZZEoKXxxF_7xt/view?usp=sharing"
            target="_blank">
            <span style="color: #0066cc; float: left">- Quy định cửa TGĐ về hợp đồng CTV và hợp đồng thiết bị đối với trường, xã, phường thí điểm ngày 04/05/2026
            </span> 
          </a>
        </li>
          <li style="list-style: none ; ">
          <a href="https://drive.google.com/file/d/132IrNf0iKgmVzs6Td3Ck_rVBGBgalTNA/view?usp=sharing"
            target="_blank">
            <span style="color: #0066cc; float: left">- Quy định của TGĐ về thiết bị của hợp đồng C1,C2,Cn ngày 01/05/2026
            </span> 
          </a>
        </li>
        <li style="list-style: none ; ">
          <a href="https://drive.google.com/file/d/1g9M5-uwVEGVXBBovvAnUkt59btGyRKw3/view?usp=sharing"
            target="_blank">
            <span style="color: #0066cc; float: left">- Quy định của TGD về hợp đồng thiết bị đối với nhân viên ngày 01/05/2026
            </span>  
          </a>
        </li>
       
         <li style="list-style: none ; ">
          <a href="https://docs.google.com/spreadsheets/d/1ZtCMt4tT2n7Zojmd4OGOuMklCP61rDeT/edit?usp=sharing&ouid=106701618316117730835&rtpof=true&sd=true"
            target="_blank">
            <span style="color: #0066cc; float: left">{{currentLanguage.body_text_congty_Hoatdongkinhdoanh2026}}
            </span> 
          </a>
        </li>
        <li style="list-style: none">
        <a href="https://drive.google.com/file/d/1Sk7dlcgcqjd52oGeC5mgwZVNvyZ6mxEE/view?usp=sharing"
            target="_blank">
            <span style="color: #0066cc; float: left">{{currentLanguage.text_cOdONG_QuyDinhTaiXaPhuongTD2}}
            </span> 
          </a>
        </li>
          <!-- <li style="list-style: none">
        <a href="https://drive.google.com/file/d/1U4X88ttSYv3K_vpjRFv_6YjVEoS2FT0Sl/view?usp=sharing"
            target="_blank">
            <span style="color: #0066cc; float: left">{{currentLanguage.body_text_congty_quyDInhgiabanle}}
            </span> 
          </a>
        </li> -->
        <!-- <li style="list-style: none">
          <a href="https://drive.google.com/file/d/1HdsPsaqUXYCei83N0myjMHCMe6ggWEZ0/view?usp=sharing"
            target="_blank">
            <span style="color: #0066cc; float: left">{{ currentLanguage.text_cOdONG_QuyDinhTaiXaPhuongTD }}
            </span> 
          </a>
        </li> -->
               <li style="list-style: none">
          <a href="https://drive.google.com/file/d/1xCe17de-5dPSboz5lU0QTW3UbQd7mEK-/view?usp=sharing"
            target="_blank">
            <span style="color: #0066cc; float: left">{{ currentLanguage.body_text_congty_codong_Dieulevimass }}
            </span> 
          </a>
        </li>
         <li style="list-style: none">
          <a href="https://drive.google.com/file/d/16qtYQrfkQiV9yNlFYdnI4zA8Ah3r3ZCi/view?usp=sharing"
            target="_blank">
            <span style="color: #0066cc; float: left">{{ currentLanguage.body_text_congty_codong_NGHIQUYETDHCD2026 }}
            </span> 
          </a>
        </li>
     
        <li style="list-style: none">
          <a href="https://drive.google.com/file/d/1H7H6Y_w_RnLYTmXseuuKE0dCrTso5B8d/view?usp=sharing"
            target="_blank">
            <span style="color: #0066cc; float: left">{{ currentLanguage.body_text_congty_codong_BienbanDHCD2026 }}
            </span> 
          </a>
        </li>
       
           <li style="list-style: none">
          <a href="https://drive.google.com/file/d/16sShmDj-HwlOX64xxNoyYJcCSlHfA9f8/view?usp=sharing"
            target="_blank">
            <span style="color: #0066cc; float: left">{{ currentLanguage.body_text_congty_codong_Danhsachcodongvavongopngay12102025 }}
            </span> 
          </a>
        </li>
         <li style="list-style: none">
          <a href="https://drive.google.com/file/d/1KRyvL4nu8Scs9Kj9Uxm5NkSheLhlFu6Z/view?usp=sharing"
            target="_blank">
            <span style="color: #0066cc; float: left">{{ currentLanguage.text_cOdONG_QuyDinhTGDTAITROVSOUND }}
            </span> 
          </a>
        </li>
             
         <li style="list-style: none ;">
          <a href="https://drive.google.com/file/d/1XBrCE9ZEHV-o_2t8So3LItxoDOAT85DL/view?usp=sharing"
            target="_blank">
            <span style="color: #0066cc; float: left">{{currentLanguage.body_text_congty_baoCaoCuaTGD}}
            </span> 
          </a>
        </li>
         <li style="list-style: none ;">
          <a href="https://drive.google.com/file/d/1VE2tAAZ1EgAV_244ApbbZScLusQSo2ks/view?usp=sharing"
            target="_blank">
            <span style="color: #0066cc; float: left">{{currentLanguage.body_text_congty_GiayMoiHopDHCD2026}}
            </span> 
          </a>
        </li>
          <li style="list-style: none ;">
          <a href="https://drive.google.com/file/d/1lqtt4JCxqLK6xLaywm4tpa7bmPP-TOKl/view?usp=sharing"
            target="_blank">
            <span style="color: #0066cc; float: left">{{currentLanguage.body_text_congty_quyDInhthaydoithunhapt42026}}
            </span> 
          </a>
        </li>
         
        <li style="list-style: none">
          <a href="https://drive.google.com/file/d/1GKulz9eFBfOsxPBJcIs_wQfmswvxNh6s/view?usp=sharing"
            target="_blank">
            <span style="color: #0066cc; float: left">{{ currentLanguage.body_text_congty_codong_Giayuyquyen}}
            </span> 
          </a>
        </li>
         <li style="list-style: none">
          <a href="https://drive.google.com/file/d/1rpGOHjif5PRa-dD131jwMXf0U9YkRyQN/view?usp=sharing"
            target="_blank">
            <span style="color: #0066cc; float: left">{{ currentLanguage.body_text_congty_codong_ThanhlapVimassHU}}
            </span> 
          </a>
        </li>
       
      
         
         <li style="list-style: none">
          <a href="https://drive.google.com/file/d/1TUSm31ReAzvXb4dMemQ1MCVMpdftpZW6/view?usp=sharing"
            target="_blank">
            <span style="color: #0066cc; float: left">{{ currentLanguage.body_text_congty_codong_quydinhmahoa }}
            </span> 
          </a>
        </li>
         <!-- <li style="list-style: none">
          <a href="https://drive.google.com/file/d/1wZdsjB8eftlp9VE-mxeWyhfPIV1QgFqN/view?usp=sharing"
            target="_blank">
            <span style="color: #0066cc; float: left">{{ currentLanguage.body_text_congty_codong_Thongbaouyquyen }}
            </span> 
          </a>
        </li> -->
       
          <li style="list-style: none">
          <a href="https://drive.google.com/file/d/1pyQmr1WB3N7NPkSKI1wx_BWBGu9CaJpG/view?usp=sharing"
            target="_blank">
            <span style="color: #0066cc; float: left">{{ currentLanguage.body_text_congty_codong_Vanbancamket }}
            </span> 
          </a>
        </li>
   
        
      <li style="list-style: none">
             <a href="https://drive.google.com/file/d/1I6H1rSFksmRk78pvE2DfV7pfXwLmxA3I/view?usp=sharing"
       target="_blank">
            <span style="color: #0066cc; float: left">{{currentLanguage.body_text_congty_phidv}}
            </span> 
          </a>
        </li>
         <!-- <li style="list-style: none">
          <a href="https://drive.google.com/file/d/1q5Wu4dS8JP4jWGBHJVP-DnAvEZnNBy3N/view?usp=sharing"
            target="_blank">
            <span style="color: #0066cc; float: left">{{currentLanguage.body_text_congty_CongVanBIDV}}
            </span> 
          </a>
        </li> -->
        <li style="list-style: none">
          <a href="https://drive.google.com/file/d/1nmT--8fm1iSluwel3dSWOivYbCPHRqfd/view?usp=sharing"
            target="_blank">
            <span style="color: #0066cc; float: left">{{currentLanguage.body_text_congty_ThayDoiPhiAPI}}
            </span> 
          </a>
        </li>
        <li style="list-style: none">
          <a href="https://drive.google.com/file/d/1C1wlG2wT92CHbsPGfQ2l47b3j4tx4SIU/view?usp=sharing"
            target="_blank">
            <span style="color: #0066cc; float: left">{{currentLanguage.body_text_congty_DieuChinhluong}}
            </span> 
          </a>
        </li>
        
      
        <li style="list-style: none">
          <a href="https://drive.google.com/file/d/1api4u6o3okSEspfIswAtBKQtNnBxNt0n/view?usp=sharing"
            target="_blank">
            <span style="color: #0066cc; float: left">{{currentLanguage.body_text_congty_Thongbaouyquyen}}
            </span> 
          </a>
        </li>
        
         <li style="list-style: none">
          <a href="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1772781558212458BF"
            target="_blank">
            <span style="color: #0066cc; float: left">{{currentLanguage.body_text_congty_khauhaothietbi}}
            </span> 
          </a>
        </li>


          <li style="list-style: none">
          <a href="https://drive.google.com/file/d/1jxaIdjMYI5O6jYN5lhpcCbBDuvsFv-7_/view?usp=sharing"
            target="_blank">
            <span style="color: #0066cc; float: left">{{currentLanguage.body_text_congty_ThongbaonghiavuthueTVT}}
            </span> 
          </a>
        </li>
         
         
          <li style="list-style: none">
          <a href="https://drive.google.com/file/d/1uDdHxBn-vW-QYkTfNw_AADe2vLCDXYmQ/view?usp=sharing"
            target="_blank">
            <span style="color: #0066cc; float: left">{{currentLanguage.body_text_congty_quyDInhthaydoithunhap2026}}
            </span> 
          </a>
        </li>
           <li style="list-style: none">
          <a href="https://drive.google.com/file/d/1N4JXOPeM-WtWQijN_CRVsZGxw2jP1QMu/view?usp=sharing"
            target="_blank">
            <span style="color: #0066cc; float: left">{{currentLanguage.body_text_congty_quyDInhqrtaikhoantrnggian}}
            </span> 
          </a>
        </li>
         <li style="list-style: none">
          <a href="https://drive.google.com/file/d/1I4nIFbGSoZidEwZal_A6aGDIMsLJtzou/view"
            target="_blank">
            <span style="color: #0066cc; float: left">{{currentLanguage.body_text_congty_quyDInhthuethietbi}}
            </span> 
          </a>
        </li>
        
         <li style="list-style: none">
          <a href="https://docs.google.com/spreadsheets/d/18H9SWKExF1YcYHi4boEBBM_2qm5eu5z7/edit?usp=sharing&ouid=106701618316117730835&rtpof=true&sd=true"
            target="_blank">
            <span style="color: #0066cc; float: left">{{ currentLanguage.body_text_congty_HoatdongkinhdoanhThang32025 }}
            </span> 
          </a>
        </li>
          <li style="list-style: none">
          <a href="https://drive.google.com/file/d/1O8H44uMK-vsNO_gcIZKADLmz6SJnUU79/view?usp=sharing"
            target="_blank">
            <span style="color: #0066cc; float: left">{{ currentLanguage.body_text_congty_codong_QuydinhQRtktrunggian }}
            </span> 
          </a>
        </li>

           <li style="list-style: none">
          <a href="https://drive.google.com/file/d/1gxNrQTPAYt0fF-p3do4GDy942_207poO/view?usp=sharing"
            target="_blank">
            <span style="color: #0066cc; float: left">{{ currentLanguage.body_text_congty_codong_thongbaothuectcpvimass }}
            </span> 
          </a>
        </li>


  <li style="list-style: none">
          <a href="https://drive.google.com/file/d/1NnAWLBhEvws1R_4RVHVe2IbW8z7n1Xec/view?usp=sharing"
            target="_blank">
            <span style="color: #0066cc; float: left">{{ currentLanguage.body_text_congty_codong_hOPDONGVIMASSDOLOC }}
            </span> 
          </a>
        </li>


         <li style="list-style: none">
          <a href="https://drive.google.com/file/d/1kgH_HgT6odupnWb97m18o7fq7BmAB9dX/view?usp=sharing"
            target="_blank">
            <span style="color: #0066cc; float: left">{{ currentLanguage.body_text_congty_CoDongBatThuong1212 }}
            </span> 
          </a>
        </li>

        <li style="list-style: none">
          <a href="https://drive.google.com/file/d/1VZrLJYU-xEKe1BFIpC8drSSq05SxFP5J/view?usp=sharing"
            target="_blank">
            <span style="color: #0066cc; float: left">{{ currentLanguage.body_text_congty_BienBanCoDongBatThuong1212 }}
            </span> 
          </a>
        </li>
       

       
         <li style="list-style: none">
          <a href="https://drive.google.com/file/d/1ysYDaK6JQn1tZ-W3m0PmSfU3o-T0uYFp/view?usp=sharing"
            target="_blank">
            <span style="color: #0066cc; float: left">{{ currentLanguage.body_text_congty_Baocaotaitro20256 }}
                </span> 
          </a>
               </li>
    
           
            <!-- <li>
          <a target="_blank" href="https://drive.google.com/file/d/1TSvy9dEmmK0794bBuEzjDl79zFKW6CZh/view?usp=sharing">
            <span style="color: #0066cc; float: left">{{
              currentLanguage.body_text_congty_codong_Danhsachcodongvavongopngay04052025
            }}
            </span>
          </a>
        </li> -->
          <li class="d-none">
          <a target="_blank" href="https://drive.google.com/file/d/1aGGUogvn4_KXsbdch4L8IavnaS7eddGA/view?usp=sharing">
            <span style="color: #0066cc; float: left">{{
              currentLanguage.body_text_congty_codong_Dieulecty
            }}
            </span>
          </a>
        </li>
          <li>
          <a target="_blank" href="https://drive.google.com/file/d/11r2XYLq4UuNIHqT_vGodabC_X6BJXzHn/view?usp=sharing">
            <span style="color: #0066cc; float: left">{{
              currentLanguage.body_text_congty_codong_Dangkykinhdoanhlanthu26ngay251125
            }}
            </span>
          </a>
        </li>
        <li>
          <a target="_blank" href="https://drive.google.com/file/d/1-xRDEYqRA76jLUab74X2DIC_oDUO_FC9/view?usp=sharing">
            <span style="color: #0066cc; float: left">{{
              currentLanguage.body_text_congty_codong_Giayphepxuatkhausanphamdichvumatmadansu4102025
            }}
            </span>
          </a>
        </li>
        
         <li>
          <a target="_blank" href="https://drive.google.com/file/d/1BI1QbiYZ41-FfsmvVDdwnKr4IwaEgr7I/view?usp=sharing">
            <span style="color: #0066cc; float: left">{{
              currentLanguage.body_text_congty_codong_Danhsachcodongvavongopngay04052023
            }}
            </span>
          </a>
        </li>
        <li>
          <a target="_blank" href="https://drive.google.com/file/d/1PL9g6PMndHT7wmmc7xjPUeWDtyHoi2GX/view?usp=sharing">
            <span style="color: #0066cc; float: left">{{
              currentLanguage.body_text_congty_codong_Giayphepkinhdoanhsanphamdichvumatmadansu4102025
            }}
            </span>
          </a>
        </li> 
      <li style="list-style: none">
          <a href="https://drive.google.com/file/d/1iiPjGAMe49r55leJU-KidDXJlkWdqbfN/view?usp=sharing" target="_blank">
            <span style="color: #0066cc; float: left">{{ currentLanguage.body_text_congty_QDquydinhluutrubaomat }}
            </span>
          </a>
        </li>
        
          
         <!-- <li style="list-style: none">
          <a href="https://docs.google.com/spreadsheets/d/14CjtGHySmRC_dTsr20dHoLuznJweQL2A/view?usp=sharing"
            target="_blank">
            <span style="color: #0066cc; float: left">{{ currentLanguage.body_text_congty_HoatdongkinhdoanhThang32025 }}
            </span> 
          </a>
        </li> -->
         <li style="list-style: none">
          <a href="https://drive.google.com/file/d/1om3tcuBqePZg1GHDiKSBApBwwuyTBCL9/view?usp=sharing" target="_blank">
            <span style="color: #0066cc; float: left">{{
              currentLanguage.body_text_congty_codong_QDnongnghiep }}
            </span>
          </a>
          
        </li>
      
         <li style="list-style: none">
          <a :href="currentLanguage.driverQDytethongming" target="_blank">
            <span style="color: #0066cc; float: left">{{
              currentLanguage.body_text_congty_codong_QDdiemyte }}
            </span>
          </a>
        </li>
       
            <li style="list-style: none">
          <a :href="currentLanguage.driverQDdiemgiamsatgiaothong" target="_blank">
            <span style="color: #0066cc; float: left">{{
              currentLanguage.body_text_congty_codong_QDdiemgiamsatvagiaothong }}
            </span>
          </a>
        </li>
       
         <li style="list-style: none">
          <a :href="currentLanguage.driverQDdiemichvuthanhtoan" target="_blank">
            <span style="color: #0066cc; float: left">{{
              currentLanguage.body_text_congty_codong_QDdiemdichvuvathanhtoan }}
            </span>
          </a>
        </li>
            <li style="list-style: none">
          <a href="https://drive.google.com/file/d/1SILrA9ayeH-bQuCsbfTmbV8vMGC37HSC/view" target="_blank">
            <span style="color: #0066cc; float: left">{{
              currentLanguage.body_text_congty_codong_QDphancongtrienkhaitaitrotruonghocthang9 }}
            </span>
          </a>
          
        </li>
          <li style="list-style: none">
          <a :href="currentLanguage.driverQDvidientu"
            target="_blank">
            <span style="color: #0066cc; float: left">{{ currentLanguage.body_text_congty_codong_231027quydinhvevidientu }}
            </span> 
          </a>
        </li>
         <li style="list-style: none">
          <a href="https://drive.google.com/file/d/1SE_RDKnaRITaZj3kpRBiGu6zLPMzutfd/view?usp=sharing" target="_blank">
            <span style="color: #0066cc; float: left">{{
              currentLanguage.body_text_congty_codong_QDchinsachvachietkhau }}
            </span>
          </a>
        </li>
    
        
         <!-- <li style="list-style: none">
          <a href="https://docs.google.com/spreadsheets/d/1ifBeHOQ1T6L4CBPVZftX0UXTiv2OsEee/edit?usp=sharing&ouid=106701618316117730835&rtpof=true&sd=true"
            target="_blank">
            <span style="color: #0066cc; float: left">{{ currentLanguage.body_text_congty_HoatdongkinhdoanhThang32025 }}
            </span> 
          </a>
        </li> -->
         <li style="list-style: none">
          <a :href="currentLanguage.img_tangluong" target="_blank">
            <span style="color: #0066cc; float: left">{{
              currentLanguage.body_QuyetdinhtanglluongCBNVt10 }}
            </span>
          </a>
        </li>
       <li style="list-style: none">
          <a href="https://drive.google.com/file/d/1MASizYhW_SRV5vdlND_nW7FzdFyahlbY/view?usp=sharing" target="_blank">
            <span style="color: #0066cc; float: left">{{
              currentLanguage.boddy_text_saokeQuy3 }}
            </span>
          </a>
        </li>
          
           <li style="list-style: none">
          <a href="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1757229089972cYl9F" target="_blank">
            <span style="color: #0066cc; float: left">{{
              currentLanguage.body_QuyetdinhtanglluongCBNV }}
            </span>
          </a>
        </li>
        <!-- <li style="list-style: none">
          <a href="https://docs.google.com/spreadsheets/d/1BnmRI-VzYJDHWdj2NGnVGzfAk-VqGsro/edit?usp=sharing&ouid=106701618316117730835&rtpof=true&sd=true"
            target="_blank">
            <span style="color: #0066cc; float: left">{{ currentLanguage.body_text_congty_HoatdongkinhdoanhThang32025 }}
            </span> 
          </a>
        </li> -->
           <li style="list-style: none">
          <a href="https://drive.google.com/file/d/1pOOU9FIi_rgpMmHYxH4B7XWBw8O-40E9/view?usp=sharing"
            target="_blank">
            <span style="color: #0066cc; float: left">{{ currentLanguage.body_text_congty_CoDongBatThuong }}
            </span> 
          </a>
        </li> 
        <li style="list-style: none">
          <a href="https://drive.google.com/file/d/1j0DqMGNidUoi3WSloVJfnHFERPB3kGuf/view?usp=sharing"
            target="_blank">
            <span style="color: #0066cc; float: left">{{ currentLanguage.body_text_congty_BienBanCoDongBatThuong }}
            </span> 
          </a>
        </li>    
         
      
         <li style="list-style: none">
          <a href="https://drive.google.com/file/d/1CO5jS9ekWYxvC7HKHl_XSPxUf54LG-Su/view?usp=sharing" target="_blank">
            <span style="color: #0066cc; float: left">{{
              currentLanguage.body_text_congty_codong_QDchamdutquyencuactv }}
            </span>
          </a>
        </li>
          <li style="list-style: none">
          <a href="https://drive.google.com/file/d/1qB5KE6qL2orV3WMR7cQTpYmgH1ji6AZ7/view?usp=sharing" target="_blank">
            <span style="color: #0066cc; float: left">{{
              currentLanguage.body_text_congty_codong_QDphancongtrienkhaitaitrotruonghoc }}
            </span>
          </a>
        </li>
        <li style="list-style: none">
          <a href="https://drive.google.com/file/d/1pAT9ULoVSVeLddiy2aXur7R77UoYVtcr/view?usp=sharing" target="_blank">
            <span style="color: #0066cc; float: left">{{
              currentLanguage.body_text_congty_codong_NhomtuvanXAThiDiem }}
            </span>
          </a>
        </li>
           <li style="list-style: none">
          <a href="https://drive.google.com/file/d/17dlkinkt3fWtTb5-HPR9RFK7MM2n_6lg/view?usp=sharing" target="_blank">
            <span style="color: #0066cc; float: left">{{
              currentLanguage.body_text_congty_codong_PhiDichVuVimass }}
            </span>
          </a>
        </li>          
        
          <li style="list-style: none">
          <a href="https://drive.google.com/file/d/1R0SQ5u6iM6k2uPUi429rQRhHctKGDphP/view?usp=sharing"
            target="_blank">
            <span style="color: #0066cc; float: left">{{ currentLanguage.body_text_congty_GiayMoiHopDHCD }}
            </span>
          </a>
        </li>
         <li style="list-style: none">
          <a href="https://drive.google.com/file/d/1R0SQ5u6iM6k2uPUi429rQRhHctKGDphP/view?usp=sharing"
            target="_blank">
            <span style="color: #0066cc; float: left">{{ currentLanguage.body_text_congty_NghiQuyetHDQTtangVon }}
            </span>
          </a>
        </li>    
        <li style="list-style: none">
          <a href="https://drive.google.com/file/d/1D8lESuFKeFa3XfrHaJT_OCJ0vQY3DH5J/view?usp=sharing" target="_blank">
            <span style="color: #0066cc; float: left">{{
              currentLanguage.boddy_text_saokeQuy2 }}
            </span>
          </a>
        </li>  
        <li>
          <a target="_blank" href="https://drive.google.com/file/d/122zqH7Nf03LF9T1sRg8PwOHhQyKYo435/view?usp=sharing">
            <span style="color: #0066cc; float: left">{{
              currentLanguage.body_text_congty_codong_Quydinhvephi
            }}
            </span>
          </a>
        </li>
         
        <li style="list-style: none">
          <a href="https://drive.google.com/file/d/10_cRSb2UKuaFmn6wi9oc-Mu_vYHjLon5/view?usp=sharing" target="_blank">
            <span style="color: #0066cc; float: left">{{
              currentLanguage.body_text_congty_codong_QDphancongtrienkhaitaitrotruonghoc02042025 }}
            </span>
          </a>
        </li>
        
        <li style="list-style: none">
          <a href="https://drive.google.com/file/d/16d2C4-fNY-8dCnMesy6np0pyvLSrsphV/view?usp=sharing" target="_blank">
            <span style="color: #0066cc; float: left">{{ currentLanguage.body_text_congty_NghiquyetHDTaiTroTruongHoc }}
            </span>
          </a>
        </li>




        <!-- <li style="list-style: none">
          <a
            href="https://drive.google.com/file/d/1urKnrKctx7Osi2Jvl3QNc-rz8Qo6x22-/view?usp=sharing"
            target="_blank"
          >
            <span style="color: #0066cc; float: left"
              >{{ currentLanguage.body_text_congty_Taitrotruongththcsthpt02042025 }}
            </span>
          </a>
        </li> -->
<li style="list-style: none">
          <a href="https://drive.google.com/file/d/1nNDhg0vIUsHT4vfCrKm7gAsKT-6D5tJC/view?usp=sharing" target="_blank">
            <span style="color: #0066cc; float: left">{{
              currentLanguage.boddy_text_saokeQuy1 }}
            </span>
          </a>
        </li>
        <li style="list-style: none">
          <a href="https://drive.google.com/file/d/15acSB2lXwwb4_2q91XYqMxsS_8cw8ycX/view?usp=sharing" target="_blank">
            <span style="color: #0066cc; float: left">{{
              currentLanguage.body_text_congty_codong_NghiQuyetDHDCD_thuongnien3132025 }}
            </span>
          </a>
        </li>
        <li style="list-style: none">
          <a href="https://drive.google.com/file/d/1E7OkfmeJmrjA3J9HFZlmD1dwMcpa5Kt8/view?usp=sharing" target="_blank">
            <span style="color: #0066cc; float: left">{{
              currentLanguage.body_text_congty_codong_BienBanDHDCD_thuongnien3132025 }}
            </span>
          </a>
        </li>
        <li style="list-style: none">
          <a href="https://drive.google.com/file/d/1ZoDgiNmqkt7shSycxyRf8mnLMk3mpJH3/view?usp=sharing" target="_blank">
            <span style="color: #0066cc; float: left">{{
              currentLanguage.body_text_congty_codong_QDveviectiepnhanvasudungtientaitrotruonghoc }}
            </span>
          </a>
        </li>
      


        <li style="list-style: none">
          <a href="https://drive.google.com/file/d/11RF-5E5-VAHQOLMVZ2xatbfp69cc9-Ey/view?usp=sharing" target="_blank">
            <span style="color: #0066cc; float: left">{{
              currentLanguage.body_text_congty_codong_Baocaokiemtoan2024CongTyCoPhanDichVuNenDiDongVietNamn }}
            </span>
          </a>
        </li>
      
        <!-- <li style="list-style: none">
          <a href="https://docs.google.com/spreadsheets/d/1bSjwvdfVveSYJqKDQkX2UPEPkGXcQAe4/edit?usp=sharing&ouid=106701618316117730835&rtpof=true&sd=true"
            target="_blank">
            <span style="color: #0066cc; float: left">{{ currentLanguage.body_text_congty_Hoatdongkinhdoanh2025 }}
            </span>
          </a>
        </li> -->
        <li style="list-style: none">
          <a href="https://drive.google.com/file/d/1Mo3oXScTbf-5i7FTIMiFY0mUl7ISMqy5/view?usp=sharing" target="_blank">
            <span style="color: #0066cc; float: left">{{ currentLanguage.body_text_congty_Taitrotruongththcsthpt}}
            </span>
          </a>
        </li>



        <li style="list-style: none">
          <a href="https://docs.google.com/spreadsheets/d/1jGgCVPXJZyEjq13c6BJaahkCR04g_1As/edit?usp=sharing&ouid=106701618316117730835&rtpof=true&sd=true"
            target="_blank">
            <span style="color: #0066cc; float: left">{{ currentLanguage.body_text_congty_Hoatdongkinhdoanh2024 }}
            </span>
          </a>
        </li>

        <li style="list-style: none">
          <a href="https://drive.google.com/file/d/1CzxxwerVKmqoQ9ocFIYRN8WMVu0ZEPwh/view?usp=sharing" target="_blank">
            <span style="color: #0066cc; float: left">{{
              currentLanguage.body_text_congty_codong_CuaHangVaHoTroTHuCHiCuahang }}
            </span>
          </a>
        </li>
        <li style="list-style: none">
          <a href="https://drive.google.com/file/d/1gdIc5mDVpJHUu-J-deZdca_p4aLd2zZA/view?usp=sharing" target="_blank">
            <span style="color: #0066cc; float: left">{{
              currentLanguage.body_text_congty_codong_NghiQuyetHDQTVeTaiTroThiDiem }}
            </span>
          </a>
        </li>



        <li>
          <a target="_blank" href="https://drive.google.com/file/d/1vIH7RJo4ntVSREZHEmAPOEKEc-SPvc_B/view?usp=sharing">
            <span style="color: #0066cc; float: left">{{
              currentLanguage.body_text_congty_codong_ChuCapHoiToanHoc
            }}
            </span>
          </a>
        </li>


        <li>
          <a target="_blank" href="https://drive.google.com/file/d/18cnmyUOJmpnCBeKeKZV0ERMEsvN7QPJN/view?usp=sharing">
            <span style="color: #0066cc; float: left">{{
              currentLanguage.body_text_congty_codong_BienbanhopHDQTVimassngay05082004
            }}
            </span>
          </a>
        </li>

        <li>
          <a target="_blank" href="https://drive.google.com/file/d/1wEgBYOfRDoKHThOf-dj_Q575_m30MnR7/view?usp=sharing">
            <span style="color: #0066cc; float: left">{{
              currentLanguage.body_text_congty_codong_QDBanHanhbotieuchi
            }}
            </span>
          </a>
        </li>
        <li>
          <a target="_blank" href="https://drive.google.com/file/d/1Ew0CvmiT2hN-8ftcSUzMDxjK611mZW1p/view?usp=sharing">
            <span style="color: #0066cc; float: left">{{
              currentLanguage.body_text_congty_codong_ThucHienQuyDinhChinhPhu
            }}
            </span>
          </a>
        </li>
          <li>
          <a target="_blank" href="https://drive.google.com/file/d/12hs9DcF2AFc1eOHXGe4dWosV5zFQsXM4/view?usp=sharing">
            <span style="color: #0066cc; float: left">{{
              currentLanguage.body_text_congty_codong_ThucHienQuyDinantoanbaomat
            }}
            </span>
          </a>
        </li>
 <li>
          <a target="_blank" href="https://drive.google.com/file/d/16VL3zY9xa1AjbZ1lTB1D_BpVMohj4Zcr/view?usp=sharing">
            <span style="color: #0066cc; float: left">{{
              currentLanguage.body_text_congty_codong_quychebaoveantoancanhan
            }}
            </span>
          </a>
        </li>
        <li>
          <a target="_blank" href="https://drive.google.com/file/d/1BrTfKdQJbSvml20DxVaLQChYEEktrUH8/view?usp=sharing">
            <span style="color: #0066cc; float: left">{{
              currentLanguage.body_text_congty_codong_dulieucanhan
            }}
            </span>
          </a>
</li>
      
        
        <li>
          <a target="_blank" href="https://drive.google.com/file/d/1mnE7Ll17gqI7VWeBOeIMfAijOnVT9Kbz/view?usp=sharing">
            <span style="color: #0066cc; float: left">{{
              currentLanguage.body_text_congty_codong_DVTGTT
            }}
            </span>
          </a>
        </li>


        <li>
          <a target="_blank" href="https://drive.google.com/file/d/1wLbmQYUopbXefy3ovHrlj4m_4_io59Xa/view?usp=sharing">
            <span style="color: #0066cc; float: left">{{
              currentLanguage.body_text_congty_codong_ThongtuNHNN
            }}
            </span>
          </a>
        </li>
        <li>
          <a target="_blank" href="https://drive.google.com/file/d/1r7FcqKY3IADFkhBrSWwR3eAowpjTnmUH/view?usp=sharing">
            <span style="color: #0066cc; float: left">{{
              currentLanguage.body_text_congty_codong_BienbanhopDaihoidongcodongthuongnien2023ngay25042024
            }}
            </span>
          </a>
        </li>


        <li>
          <a target="_blank" href="https://drive.google.com/file/d/1pmC8OfM_JoJ873fDtHJTGFj-oBOpLecR/view?usp=sharing">
            <span style="color: #0066cc; float: left">{{
              currentLanguage.body_text_congty_codong_HoSoCapDoAnToanHTTTVIMASS
            }}
            </span>
          </a>
        </li>

        <li style="list-style: none">
          <a target="_blank" :href="lang === 'vi'
            ? 'https://drive.google.com/file/d/16YSpIdry2RDd_0U3C4gtV34VBnuAvKS3/view?usp=sharing'
            : lang === 'en'
              ? 'https://drive.google.com/file/d/1tOHPNL_lgFy6iXXsc2RUNwMRG9tfOsbq/view?usp=sharing'
              : lang === 'cn'
                ? 'https://drive.google.com/file/d/1tOHPNL_lgFy6iXXsc2RUNwMRG9tfOsbq/view?usp=sharing'
                : lang === 'kr'
                  ? 'https://drive.google.com/file/d/1tOHPNL_lgFy6iXXsc2RUNwMRG9tfOsbq/view?usp=sharing'
                  : 'https://drive.google.com/file/d/1tOHPNL_lgFy6iXXsc2RUNwMRG9tfOsbq/view?usp=sharing'
            ">
            <span style="color: #0066cc; float: left">{{
              currentLanguage.body_text_congty_codong_Baocaokiemtoan2023CongTyCoPhanDichVuNenDiDongVietNamn
            }}
            </span>
          </a>
        </li>


        <li>
          <a href="https://drive.google.com/file/d/1ch2fOQ3ayG5Hi07-NoncehexSMEExAzk/view?usp=sharing" target="_blank">
            <span style="color: #0066cc; float: left">{{
              currentLanguage.body_text_congty_codong_Giayphepxuatkhaunhapkhausanphammatmadansungay050224
            }}
            </span>
          </a>
        </li>

        <li>
          <a target="_blank" href="https://drive.google.com/file/d/1VInTfiuGyS9IgUqu5eR26GxG_xI_GdlP/view?usp=sharing">
            <span style="color: #0066cc; float: left">{{ currentLanguage.body_text_congty_codong_Bien_ban_hop_HDQT }}
            </span>
          </a>
        </li>

        <li style="list-style: none">
          <a href="https://docs.google.com/spreadsheets/d/1DMe6WUhxBRTMKYTtjwRHdyE_t1LeWYWx/edit?usp=sharing&ouid=106701618316117730835&rtpof=true&sd=true"
            target="_blank">
            <span style="color: #0066cc; float: left">{{ currentLanguage.body_text_congty_Hoatdongkinhdoanh }}
            </span>
          </a>
        </li>

        <li>
          <a target="_blank" href="https://drive.google.com/file/d/1jR0PnGjFFYnzspxL-4QoPz51uEROmyXJ/view?usp=sharing">
            <span style="color: #0066cc; float: left">{{
              currentLanguage.body_text_congty_codong_231027QuyetDinhThanhLapBanAnToanThongTin
            }}
            </span>
          </a>
        </li>

        <li>
          <a target="_blank" href="https://drive.google.com/file/d/1EnTkCe-WjOEd8fzimVofeh5XztEbJ5Xx/view?usp=sharing">
            <span style="color: #0066cc; float: left">{{
              currentLanguage.body_text_congty_codong_23_9_5_Quyet_dinh_phan_cong_nhiem_vu
            }}
            </span>
          </a>
        </li>

        <li style="list-style: none">
          <a href="https://drive.google.com/file/d/1peJ4hsHkJnqgoQmwJmZSPbvqALWBQk_K/view?usp=sharing" target="_blank">
            <span style="color: #0066cc; float: left">{{
              currentLanguage.body_text_congty_codong_Dangkykinhdoanhlanthu25
            }}
            </span>
          </a>
        </li>

        <li style="list-style: none">
          <a href="https://drive.google.com/file/d/1Uk-PjeeU3bh3NhpGCcv74AOQlWcSs0EH/view?usp=sharing" target="_blank">
            <span style="color: #0066cc; float: left">{{
              currentLanguage.body_text_congty_codong_QuyetdinhgiamgiolamCBNV
            }}
            </span>
          </a>
        </li>
        <!-- <li>
          <a
            target="_blank"
            href="https://vimass.vn/vmbank/services/media/viewFile?id=23_9_20_Thong_bao_ve_viec_dang_ky_tang_von_dieu_le.pdf"
          >
            <span style="color: #0066cc; float: left"
              >{{
                currentLanguage.body_text_congty_codong_23_9_20_Thong_bao_ve_viec_dang_ky_tang_von_dieu_le
              }}
            </span>
          </a>
        </li> -->

        <li>
          <a target="_blank" href="https://drive.google.com/file/d/1UJ87dnNydfd3XZ1mS1v8BrCZIFj7Nivo/view?usp=sharing">
            <span style="color: #0066cc; float: left">{{ currentLanguage.body_HopDong_text_thongbaogopvon }}
            </span>
          </a>
        </li>
        <li></li>

        <li style="list-style: none; display: none;">
          <a href="https://drive.google.com/file/d/1HNsLjxIi7zshmTKDlcSJvopMqX6xNAmG/view?usp=sharing" target="_blank">
            <span style="color: #0066cc; float: left">{{
              currentLanguage.body_text_congty_codong_DieuLeCongTy
            }}
            </span>
          </a>
        </li>
        <li style="list-style: none">
          <a href="https://drive.google.com/file/d/1ayALinbYqEe-IeXCLPLso5ef_Q26NL31/view?usp=sharing" target="_blank">
            <span style="color: #0066cc; float: left">{{
              currentLanguage.body_text_congty_codong_TaiLieuHuongDanRuaTien
            }}
            </span>
          </a>
        </li>
        <li style="list-style: none">
          <a href="https://drive.google.com/file/d/16MRG4LdcHNLUJZ96jtoFQ9FqiVdQN_ZV/view?usp=sharing" target="_blank">
            <span style="color: #0066cc; float: left">{{
              currentLanguage.body_text_congty_codong_phongchongruatien0723
            }}
            </span>
          </a>
        </li>

        <li style="list-style: none">
          <a href="https://drive.google.com/file/d/19R5Tqoqld0F3ibMThy9Sa8d8iSWxh3Al/view?usp=sharing" target="_blank">
            <span style="color: #0066cc; float: left">{{
              currentLanguage.body_text_congty_codong_BienbanhopDaihoicodongbatthuongngay20072023
            }}
            </span>
          </a>
        </li>

        <li>
          <a href="https://drive.google.com/file/d/1lEQAG8Rm6KvI32JUMjrS_lmA6LvQevVG/view?usp=sharing" target="_blank">
            <span style="color: #0066cc; float: left">{{
              currentLanguage.body_text_congty_codong_Dangkykinhdoanhlanthu24ngay6723
            }}
            </span>
          </a>
        </li>
        <li>
          <a target="_blank" href="https://drive.google.com/file/d/1xmsrvQE7yMiRHh1U7fNF8BIkXil4HHk1/view?usp=sharing">
            <span style="color: #0066cc; float: left">{{
              currentLanguage.body_text_congty_codong_BienbanhopHDQTVimassngay13062023
            }}
            </span>
          </a>
        </li>

        <li>
          <a target="_blank" href="https://drive.google.com/file/d/1cI617VajT2Eyom0ew6WGbWWQp7LIDNN2/view?usp=sharing">
            <span style="color: #0066cc; float: left">{{
              currentLanguage.body_text_congty_codong_23_7_3_Quyet_dinh_ve_gia_ban_thiet_bi
            }}
            </span>
          </a>
        </li>

        <!-- <li>
          <a
            target="_blank"
            href="https://web.vimass.vn/vmbank/services/media/getImage?id=nghiquyethdquantri.jpg"
          >
            <span style="color: #0066cc; float: left"
              >{{
                currentLanguage.body_text_congty_codong_NghiQuyetHoiDongQuanTri16032023
              }}
            </span>
          </a>
        </li> -->

        <li>
          <a target="_blank" href="https://drive.google.com/file/d/1wk4klwyhU3zagVZFMcSaP1uekWNNSiep/view?usp=sharing">
            <span style="color: #0066cc; float: left">{{
              currentLanguage.body_text_congty_cn_23517QuyetdinhvedailyvadongiathietbicuaVimass
            }}
            </span>
          </a>
        </li>

        <li>
          <a target="_blank" href="https://drive.google.com/file/d/1iwKEcWDD5r-KRh8ZD8_73CITeouWFinV/view?usp=sharing">
            <span style="color: #0066cc; float: left">{{
              currentLanguage.body_text_congty_codong_phongchongruatien
            }}
            </span>
          </a>
        </li>
        <li>
          <a target="_blank" href="https://drive.google.com/file/d/19lts1ZS_xMB_cSXHUOIgAx86XSPoKjSS/view?usp=sharing">
            <span style="color: #0066cc; float: left">{{
              currentLanguage.body_text_congty_codong_BienbanhopHDQTVimassngay17042023
            }}
            </span>
          </a>
        </li>

        <li>
          <a target="_blank" href="https://drive.google.com/file/d/1_Kq8_ehehNX3Syinn71pUlx2wV_QsnS_/view?usp=sharing">
            <span style="color: #0066cc; float: left">{{
              currentLanguage.body_text_congty_codong_Quyetdinhvecongtacvientaodiemthanhtoanvaphanphoithietbingay17042023
            }}
            </span>
          </a>
        </li>
        <!-- <li>
          <a
            target="_blank"
            href="https://vimass.vn/vmbank/services/media/viewFile?id=23_04_07_Bien_ban_hop_DHDCD.pdf"
          >
            <span style="color: #0066cc; float: left"
              >{{
                currentLanguage.body_text_congty_codong_BienbanhopDaihoidongcodongthuongnien2023ngay07042023
              }}
            </span>
          </a>
        </li> -->
        <!-- <li>
          <a target="_blank" href="https://drive.google.com/file/d/1epE1P0s2AWlcTAdqQqQl86oxB_QrOM23/view?usp=sharing">
            <span style="color: #0066cc; float: left">{{
              currentLanguage.body_text_congty_codong_BienbanhopHDQTVimassngay17032023
            }}
            </span>
          </a>
        </li> -->
        <li>
          <a target="_blank" href="https://drive.google.com/file/d/19cxyZokouo8JS7ZG7DArl-orELpHQRkr/view?usp=sharing">
            <span style="color: #0066cc; float: left">{{
              currentLanguage.body_text_congty_codong_Quyetdinhvenhomcongtacvienngay22022023
            }}
            </span>
          </a>
        </li>
        <!-- <li>
          <a
            href="https://vimass.vn/vmbank/services/media/viewFile?id=23_02_02_hop_dong_cung_cap_dich_vu_thu_chi_ho_cua_Vimass.pdf"
            target="_blank"
          >
            <span style="color: #0066cc; float: left"
              >{{
                currentLanguage.body_text_congty_codong_HopdongcungcapdichvuthuvachihoVimassQRVNngay02022023
              }}
            </span>
          </a>
        </li> -->
        <li>
          <a href="https://drive.google.com/file/d/1wjhUjmV0EDlllINNd5FEw7KthvRmi43H/view?usp=sharing" target="_blank">
            <span style="color: #0066cc; float: left">{{
              currentLanguage.body_text_congty_codong_QuyetdinhvephidichvutaichinhcuaVimass01022023
            }}
            </span>
          </a>
        </li>
        <li>
          <a target="_blank" href="https://drive.google.com/file/d/1_Dn6IsH0i1Rjsn4yhJa1McY02JBAuasI/view?usp=sharing">
            <span style="color: #0066cc; float: left">{{
              currentLanguage.body_text_congty_codong_QuyetdinhtrienkhaithunghiemthedanangtaiVietNamngay1712023
            }}
            </span>
          </a>
        </li>

        <li>
          <a target="_blank" href="https://drive.google.com/file/d/1XWu1q6n3Qt0nbpDS8DDmWooeI7UOya0v/view?usp=sharing">
            <span style="color: #0066cc; float: left">{{
              currentLanguage.body_text_congty_codong_QuyetdinhcapthevatemchocanbonhanvienVimassngay1612023
            }}
            </span>
          </a>
        </li>
        <!-- <li>
          <a
            target="_blank"
            href="https://vimass.vn/vmbank/services/media/viewFile?id=23_03_14_Bao_cao_hoat_dong_nam_2022_ket_qua_2_thang_2023_va_ke_hoach_2023.pdf"
          >
            <span style="color: #0066cc; float: left"
              >{{
                currentLanguage.body_text_congty_codong_Baocaohoatdongnam2022ketqua2thang2023vakehoach2023ngay14032022
              }}
            </span>
          </a>
        </li>
        <li>
          <a
            target="_blank"
            href="https://web.vimass.vn/vmbank/services/media/getImage?id=hoat_dong_kinh_doanh_2_thang_dau_nam_20223.jpg"
          >
            <span style="color: #0066cc; float: left"
              >{{
                currentLanguage.body_text_congty_codong_Hoatdongkinhdoanh2thangdaunam2023ngay14032022
              }}
            </span>
          </a>
        </li>
        <li>
          <a
            target="_blank"
            href="https://vimass.vn/vmbank/services/media/viewFile?id=23_03_08_BAO_CAO_KIEM_TOAN_2022_CTY_CP_DV_NEN_DI_DONG_VN.pdf"
          >
            <span style="color: #0066cc; float: left"
              >{{
                currentLanguage.body_text_congty_codong_Baocaokiemtoan2022CongTyCoPhanDichVuNenDiDongVietNamngay08032022
              }}
            </span>
          </a>
        </li> -->

        <li>
          <a href="https://drive.google.com/file/d/1pCPw6hig6Yo1Y4Ehk3POxESFpJ8MuaHN/view?usp=sharing" target="_blank">
            <span style="color: #0066cc; float: left">{{
              currentLanguage.body_text_congty_codong_BienbanthoathuansudungtenvalogocuaHoihuunghiVietNamHungaryngay09122022
            }}
            </span>
          </a>
        </li>
        <!-- <li>
          <a
            href="https://vimass.vn/vmbank/services/media/viewFile?id=29_11_2022_Giay_phep_xuat_nhap_khau_san_pham_mat_ma_dan_su.pdf"
            target="_blank"
          >
            <span style="color: #0066cc; float: left"
              >{{
                currentLanguage.body_text_congty_codong_Giayphepxuatkhaunhapkhausanphammatmadansungay29112022
              }}
            </span>
          </a>
        </li> -->
        <li>
          <a href="https://drive.google.com/file/d/1xxOwipHa8JnYHLC5KJovjbwqvBJq1Fmk/view?usp=sharing" target="_blank">
            <span style="color: #0066cc; float: left">{{
              currentLanguage.body_text_congty_codong_Dangkykinhdoanhlanthu22ngay11102022
            }}
            </span>
          </a>
        </li>
        <!-- <li style="list-style: none">
          <a
            href="https://vimass.vn/vmbank/services/media/viewFile?id=22_10_6_Bien_ban_hop_HDQT.pdf"
            target="_blank"
          >
            <span style="color: #0066cc; float: left"
              >{{
                currentLanguage.body_text_congty_codong_BienbanhopHDQTVimassngay06102022
              }}
            </span>
          </a>
        </li>

        <li style="list-style: none">
          <a
            href="https://vimass.vn/vmbank/services/media/viewFile?id=Bien_ban_hop_dai_hoi_co_dong_bat_thuong31082022.pdf"
            target="_blank"
          >
            <span style="color: #0066cc; float: left"
              >{{
                currentLanguage.body_text_congty_codong_BienbanhopDaihoicodongbatthuongngay31082022
              }}
            </span>
          </a>
        </li>
        <li style="list-style: none">
          <a
            href="https://vimass.vn/vmbank/services/media/viewFile?id=22_8_2_Bien_ban_hop_HĐQT.pdf"
            target="_blank"
          >
            <span style="color: #0066cc; float: left"
              >{{
                currentLanguage.body_text_congty_codong_BienbanhopHDQTVimassngay02082022
              }}
            </span>
          </a>
        </li>

        <li style="list-style: none">
          <a
            href="https://vimass.vn/vmbank/services/media/viewFile?id=Hop_dong_hop_tac_cung_cap_dich_vu_thu_va_chi_ho_vimass_qrvn_11_07_2022.pdf"
            target="_blank"
          >
            <span style="color: #0066cc; float: left"
              >{{
                currentLanguage.body_text_congty_codong_HopdonghoptaccungcapdichvuthuvachihoViMASSQRVNngay11072022
              }}
            </span>
          </a>
        </li> -->

        <li style="list-style: none">
          <a href="https://drive.google.com/file/d/1uhdkxuF51epeoT9pGiuskdNjnnlU4CRL/view?usp=sharing" target="_blank">
            <span style="color: #0066cc; float: left">{{
              currentLanguage.body_text_congty_codong_QuyetdinhcungcaptrangthietbichoCBNVngay01072022
            }}
            </span>
          </a>
        </li>

        <!-- <li style="list-style: none">
          <a
            href="https://vimass.vn/vmbank/services/media/viewFile?id=Bien_ban_hop_HDQT_31_05_2022.pdf"
            target="_blank"
          >
            <span style="color: #0066cc; float: left"
              >{{
                currentLanguage.body_text_congty_codong_BienbanhopHDQTngay31052022
              }}
            </span>
          </a>
        </li>

        <li style="list-style: none">
          <a
            href="https://web.vimass.vn/vmbank/services/media/getImage?id=DKKD_NgheAn.png"
            target="_blank"
          >
            <span style="color: #0066cc; float: left"
              >{{
                currentLanguage.body_text_congty_codong_DangkykinhdoanhlandaucuachinhanhNgheAnngay2752022
              }}
            </span>
          </a>
        </li>
        <li style="list-style: none">
          <a
            href="https://web.vimass.vn/vmbank/services/media/getImage?id=dkkd-quangninh.jpg"
            target="_blank"
          >
            <span style="color: #0066cc; float: left"
              >{{
                currentLanguage.body_text_congty_codong_DangkykinhdoanhlandaucuachinhanhQuangNinhngay20052022
              }}
            </span>
          </a>
        </li>
        <li>
          <a
            target="_blank"
            href="https://web.vimass.vn/vmbank/services/media/getImage?id=DKKD_CNHUE.png"
          >
            <span style="color: #0066cc; float: left"
              >{{
                currentLanguage.body_text_congty_codong_DangkykinhdoanhlandauchinhanhHuengay18052022
              }}
            </span>
          </a>
        </li>

        <li>
          <a
            target="_blank"
            href="https://web.vimass.vn/vmbank/services/media/getImage?id=DKKD_HAIPHONG.jpg"
          >
            <span style="color: #0066cc; float: left"
              >{{
                currentLanguage.body_text_congty_codong_DangkykinhdoanhlandauchinhanhHaiPhongngay07052022
              }}
            </span>
          </a>
        </li>
        <li>
          <a
            href="https://web.vimass.vn/vmbank/services/media/getImage?id=DKKD_chi_nhanh_Can_Tho.jpg"
            target="_blank"
          >
            <span style="color: #0066cc; float: left"
              >{{
                currentLanguage.body_text_congty_codong_DangkykinhdoanhlandauchinhanhCanThongay29042022
              }}
            </span>
          </a>
        </li>
        <li>
          <a
            href="https://vimass.vn/vmbank/services/media/viewFile?id=22_4_28_Bien_ban_Hop_HDQT.pdf"
            target="_blank"
          >
            <span style="color: #0066cc; float: left"
              >{{
                currentLanguage.body_text_congty_codong_BienbanhopHDQTngay28042022
              }}
            </span>
          </a>
        </li>
        <li>
          <a
            href="https://vimass.vn/vmbank/services/media/viewFile?id=Bao_cao_hoat_dong_quy_I_va_ke_hoach_2022.pdf"
            target="_blank"
          >
            <span style="color: #0066cc; float: left"
              >{{
                currentLanguage.body_text_congty_codong_BaocaohoatdongquyIvakehoach2022ngay26042022
              }}
            </span>
          </a>
        </li>

        <li>
          <a
            href="https://web.vimass.vn/vmbank/services/media/getImage?id=DKKD_chi_nhanh_Da_Nang.jpg"
            target="_blank"
          >
            <span style="color: #0066cc; float: left"
              >{{
                currentLanguage.body_text_congty_codong_DangkykinhdoanhlandauchinhanhDaNangngay22032022
              }}
            </span>
          </a>
        </li> -->

        <li>
          <a href="https://drive.google.com/file/d/1GXs5tCEeEd8YonZFcoWBhj9qArVXjabN/view?usp=sharing" target="_blank">
            <span style="color: #0066cc; float: left">{{
              currentLanguage.body_text_congty_codong_Dangkykinhdoanhlanthu21ngay11032022
            }}
            </span>
          </a>
        </li>

        <li>
          <a target="_blank" href="https://drive.google.com/file/d/1yJ4VlyP9-wglP6Yq1KbJjPLrTHfMk-Qr/view?usp=sharing">
            <span style="color: #0066cc; float: left">{{
              currentLanguage.body_text_congty_codong_BienbanhopDaihoicodongthuongnien2022ngay22022022
            }}
            </span>
          </a>
        </li>
        <!-- <li>
          <a
            target="_blank"
            href="https://vimass.vn/vmbank/services/media/viewFile?id=22_2 _21_Bao_cao_cua_CT HDQT_tai_DHDCD_thuong_nien.pdf"
          >
            <span style="color: #0066cc; float: left"
              >{{
                currentLanguage.body_text_congty_codong_BaocaocuaCTHDQTtaiDHDCDthuongnien21022022
              }}
            </span>
          </a>
        </li>

        <li>
          <a
            target="_blank"
            href="https://vimass.vn/vmbank/services/media/viewFile?id=Bao_cao_kiem_toan_2021.pdf"
          >
            <span style="color: #0066cc; float: left"
              >{{
                currentLanguage.body_text_congty_codong_BaocaokiemtoanVimass2021ngay27012022
              }}
            </span>
          </a>
        </li>
        <li>
          <a
            href="https://vimass.vn/vmbank/services/media/viewFile?id=22_1_25_Bien_ban_hop_HDQT.pdf"
            target="_blank"
          >
            <span style="color: #0066cc; float: left"
              >{{
                currentLanguage.body_text_congty_codong_BienbanhopHDQT2512022
              }}
            </span>
          </a>
        </li> -->        
        <!-- <li>
          <a
            href="https://web.vimass.vn/vmbank/services/media/getImage?id=DKKD_20.jpg"
            target="_blank"
          >
            <span style="color: #0066cc; float: left"
              >{{
                currentLanguage.body_text_congty_codong_Dangkykinhdoanhlanthu20ngay31122021
              }}
            </span>
          </a>
        </li> -->
        <li>
          <a href="https://drive.google.com/file/d/1PrJOOBzi42bcMycb9zyHpcyqWuh2km7F/view?usp=sharing" target="_blank">
            <span style="color: #0066cc; float: left">{{
              currentLanguage.body_text_congty_codong_BienbanhopHDQTVimassngay30112021
            }}
            </span>
          </a>
        </li>

        <li>
          <a href="https://drive.google.com/file/d/15anuxnIfUnHW6g935M6fvd3qV1Kh_-_Z/view?usp=sharing" target="_blank">
            <span style="color: #0066cc; float: left">{{
              currentLanguage.body_text_congty_codong_BienbanhopHDQTVimassngay28102021
            }}
            </span>
          </a>
        </li>


        <li>
          <a href="https://drive.google.com/file/d/1H5rWV2OTdrnTY-S0k1g0hKhc5fEtDkqq/view?usp=sharing" target="_blank">
            <span style="color: #0066cc; float: left">{{
              currentLanguage.body_text_congty_hdqt_quydinhgiaiquyettranhchap
            }}
            </span>
          </a>
        </li>
        <li>
          <a href="https://drive.google.com/file/d/1cU1enlHe7FbZWwPwEaqkzIhIW7fZx8JR/view" target="_blank">
            <span style="color: #0066cc; float: left">{{
              currentLanguage.body_text_congty_codong_ThucHienXoaTaiKhoanVi
            }}
            </span>
          </a>
        </li>
        <li>
          <a href="https://drive.google.com/file/d/16XDp2WrZdJ6O2Rdl7Arwgz-GfKcnipFx/view" target="_blank">
            <span style="color: #0066cc; float: left">{{
              currentLanguage.body_text_congty_codong_Giayphep41GPNHNNcuaNganhangnhanuoc1232018
            }}
            </span>
          </a>
        </li>

        <li>
          <a href="https://drive.google.com/file/d/1bc0jMjrXbIR8KvADK1MD7bhz_3_z160L/view?usp=sharing" target="_blank">
            <span style="color: #0066cc; float: left">{{
              currentLanguage.body_text_congty_codong_Dangkykinhdoanhlan6ngay19122013
            }}
            </span>
          </a>
        </li>
        <li>
          <a href="https://drive.google.com/file/d/1wKwGKtj2-ziD0ZrgPcDCJrkumyt6chaT/view?usp=sharing" target="_blank">
            <span style="color: #0066cc; float: left">{{
              currentLanguage.body_text_congty_codong_Dangkykinhdoanhlandaungay3152012
            }}
            </span>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { languages } from "@/components/languages";

export default {
  components: {},
  data() {
    return {
      currentLanguage: languages.vi,
      lang: "",
    };
  },
  mounted() {
    this.lang = localStorage.getItem("languages") || "vi";
  },
  created() {
    const savedLanguage = localStorage.getItem("languages") || "vi";
    if (savedLanguage && languages[savedLanguage]) {
      this.currentLanguage = languages[savedLanguage];
    }
  },
  methods: {
    changeLanguage(lang) {
      this.currentLanguage = languages[lang];
      localStorage.setItem("languages", lang);
      window.location.reload();
    },
  },
};
</script>